import React, {useEffect, useState, useRef} from 'react';
import {withRouter} from 'react-router-dom';
import {PaymentRequestButtonElement, useStripe, useElements, Elements} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Alert from "@material-ui/lab/Alert";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { makeStyles, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { auth, cloudFunctions } from '../../firebase';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
  alert: {
    margin: "10px 0px",
    width: "100%",
  },
}));

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    let id = setInterval(() => {
      savedCallback.current();
    }, delay);
    return () => clearInterval(id);
  }, [delay]);
}

const GooglePay = ({selectedPlan}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const classes = useStyles();
  const { newUser = {}} = useSelector((state) => ({
    newUser: state.newUser,
  }));
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [counter, setcounter] = useState(5);
  const [noneMessage, setNoneMessage] = useState(false)

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Jazzu designer',
        amount: 399,
      },
    });

    // Check the availability of the Payment Request API.
    pr.canMakePayment().then(result => {
      if (result) {
        setPaymentRequest(pr);
      }else {
        setNoneMessage(true)
      }
    });

    pr.on('paymentmethod', async (ev) => {
      handleSubmit(ev)
    });
  }, [stripe, elements]);

  const handleSubmit = async (ev, error) => {
    const {paymentMethod} = ev
    // Block native form submission.
    let hasError = false;
    let paymentMethodId = "";
    setLoading(true);
    setErrorMessage(null);
    setSuccess(false);
    if (!stripe || !elements) {
      return;
    }

    if (error) {
      setLoading(false);
      setErrorMessage(error.message);
      hasError = true;
    } else {
      paymentMethodId = paymentMethod.id;
    }
    if (!hasError) {
      const createSubscription = cloudFunctions.httpsCallable(
        "createSubscription"
      );
      createSubscription({
        planId: selectedPlan.id,
        accountId: newUser.uid,
        paymentMethodId: paymentMethodId,
        country: paymentMethod.billing_details.address.country,
        billingAddress: paymentMethod.billing_details.address
      })
        .then(async (res) => {
          if (newUser.password) {
            await auth.signInWithEmailAndPassword(
              newUser.email,
              newUser.password
            );
          }
          setLoading(false);
          setSuccess(true);
          ev.complete('success');
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage(err.message);
          ev.complete('error');
        });
    }
  };

  useInterval(() => {
    if (success) {
      setcounter(counter - 1);
    }
  }, 1000);

  useEffect(() => {
    if (counter <= 0) {
      window.location.reload();
    }
  }, [counter]);

  return (
    <Container component="main" maxWidth="xs">
      <Backdrop open={loading} style={{ zIndex: 10000 }}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <CssBaseline />
      <div className={classes.paper}>
        {success && (
          <Alert className={classes.alert} severity="success">
            The payment method has been successfully updated, you will be redirected to home page in {counter} seconds
          </Alert>
        )}
        {errorMessage !== null && (
          <Alert className={classes.alert} severity="error">
            {errorMessage}
          </Alert>
        )}
        {loading && 
          <Typography align="center" component="h6" variant="h6">
          Your payment is getting processed... please wait
          </Typography>
        }
        {noneMessage && 
          <Typography align="center" component="h6" variant="h6">
            Please add google pay to your browser, then you can pay faster
          </Typography>
        }
       {(!success && paymentRequest) && <PaymentRequestButtonElement options={{paymentRequest}} />}
      </div>
    </Container>
    
  );
};

function StripePayment({ history, setClose, selectedPlan }) {
  return (
    <Elements stripe={stripePromise}>
      <GooglePay history={history} setClose={setClose} selectedPlan={selectedPlan} />
    </Elements>
  );
}

export default StripePayment;